/**
 * Component pagination functionality
 *
 * Hide show product menu functionality
 * Number count of products in menu
 * @author Ryan Hutchinson (rhutchinson@lyonscg.com)
 */
'use strict';

var component = {
	data: {
		tElement: null,
		compBtn: null,
		listItems: null,
		activeClass: null,
		pagination: null,
		vTotal: null
	},

	init: function (showCount) {
		component.data.compBtn = $('.component-btn');
		component.data.listItems = $('.component-content li');
		component.data.activeClass = 'btn-active';
		component.data.tElement = $('.componentPagination .total');
		component.data.pagination = $('.componentPagination');
		component.addActiveClass(showCount);
		component.buttonClick();
	},

	/* *
	 * Creates and compiles active list items
	 *
	 * @method addActiveClass
	 * @return VOID
	 * */

	addActiveClass: function (showCount) {
		component.removeActions();

		$('.component-content li:nth-child(-n+' + showCount + ')').addClass('active');
		$('.component-content li:nth-child(' + showCount + 'n+' + showCount + ')').addClass('nthElm');

		component.checkTotal(showCount);
	},

	/* *
	 * Checks if number of listitems is less than show count.
	 * Populates data vTotal variable
	 * Passes vTotal varibable to populate total method
	 * Show pagination else hides pagination container
	 *
	 * @method checkComponentCount
	 * @return VOID
	 * */

	checkTotal: function (showCount) {
		if (component.data.listItems.length > showCount) {
			component.data.vTotal = showCount;
			component.populateTotal(component.data.vTotal);
			component.data.pagination.show();
			component.hideLi();
			component.showListItem($('.component-content li.active'));
		} else {
			component.data.pagination.hide();
			component.showListItem(component.data.listItems);
		}
	},

	/* *
	 * Hides button if active list items are less than var hCount
	 *
	 * @method hideBtn
	 * @return VOID
	 * */

	removeActions: function () {
		component.data.listItems.removeClass();
	},

	/* *
	 * Initial construct total element with active list items and total list items
	 *
	 * @method populateTotal
	 * @param {String} 	vTotal
	 * @return VOID
	 * */

	populateTotal: function (vTotal) {
		// Prints total data
		component.data.tElement.text(vTotal + '/' + component.data.listItems.length);
		component.data.compBtn.show();
	},

	/* *
	 * Button behavior click
	 *
	 * @method	buttonClick
	 * Toggles active class on list items
	 * @return VOID
	 * */

	buttonClick: function () {
		// unbind click event listener
		component.data.compBtn.unbind('click');

		// remove active class (reseting components)
		component.data.compBtn.removeClass('btn-active');

		component.data.compBtn.on('click', function () {
			$(this).toggleClass('btn-active');
			component.hideShowElements();
		});
	},

	/* *
	 * Constructs total element with active list items and total list items
	 *
	 * @method	showTotal
	 * @param {String} 	uploadedTotal
	 * @return VOID
	 * */

	showTotal: function (updatedTotal) {
		component.data.tElement.text(updatedTotal + '/' + component.data.listItems.length);
	},

	/* *
	 * Show selected elements
	 *
	 * @method	showListItem
	 * @param {String} 	elements
	 * @return VOID
	 * */

	showListItem: function (elements) {
		elements.show();
	},

	/* *
	 * Hide all list item elements
	 *
	 * @method	hideLi
	 * @param {String} 	elements
	 * @return VOID
	 * */

	hideLi: function () {
		component.data.listItems.hide();
	},

	/* *
	 * Show and hide list items
	 *
	 * Populate total element
	 *
	 * @method	hideShowElements
	 * @return VOID
	 * */

	hideShowElements: function () {
		if (component.data.compBtn.hasClass(component.data.activeClass)) {
			component.showTotal(component.data.listItems.length);
			component.showListItem(component.data.listItems);
		} else {
			component.showTotal(component.data.vTotal);
			component.hideLi();
			component.showListItem($('.component-content li.active'));
		}
	}
};
module.exports = component;
